import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import getRelayEnvironment from '../../../relayClientEnvironment';
import serverVars from 'server-vars';

function getWrapperElement() {
    const wrapperElement = document.createElement('div');
    wrapperElement.classList.add('tradeExpiringPromoContainer');
    document.body.appendChild(wrapperElement);
    return wrapperElement;
}

function importTradeExpiringPromoModal() {
    return import(
        /* webpackChunkName: "TradeExpiringPromoModalChunk" */
        '../../../TradeExpiringPromoModal/TradeExpiringPromoModal'
    ).then(mod => mod.TradeExpiringPromoModal);
}

export const expiringTradePromoAction = ({ customActionType }) => dispatch => {
    const localeDataKey = serverVars.get('localeDataKey');
    const messages = serverVars.get('messages');
    if (window.ReactIntlLocaleData) {
        addLocaleData(window.ReactIntlLocaleData[localeDataKey]);
    }
    importTradeExpiringPromoModal().then(TradeExpiringPromoModal => {
        const generalOnboardingModal = (
            <IntlProvider locale={localeDataKey} messages={messages}>
                <TradeExpiringPromoModal openOnRender environment={getRelayEnvironment()} />
            </IntlProvider>
        );
        ReactDOM.render(generalOnboardingModal, getWrapperElement());
    });

    return dispatch({ type: customActionType.actionType });
};
